// Build-time flags for Revival. Off in every production build until the owner
// says otherwise; a preview build (LOCAL_BUILD in the shot kit) turns one on to
// prove it against t7 without shipping it.
//
// REVIEW_QUEUE — the Needs-review queue (Completed / Not completed / Unknown per
// scanned quote) and Attach / Split for the different-address phone matches.
// Needs OPS's review endpoint and leg 19's work_status column on main first.
export const REVIEW_QUEUE_ON = process.env.REACT_APP_REVIVAL_REVIEW_QUEUE === "on";
